import { css } from 'styled-components';
const styles = css `
  border: ${(props) => props.borderColor ? `1px solid ${props.borderColor}` : 0};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  background-color: ${(props) => props.iconBG};
`;
export default styles;
